<template>
  <div>
    <Breadcrumb></Breadcrumb>
    <div class="common-limit line-height-40">
      <div class="form-body">
        <el-form ref="form" :model="queryParams" label-width="80px">
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="商家账号：" prop="noticeType">
                <el-select
                  clearable
                  size="small"
                  v-model="queryParams.userName"
                  filterable
                >
                  <template v-for="(value, key) in userList">
                    <el-option
                      :key="value.userName"
                      :label="`${value.userName}${
                            value.nickName ? '(' + value.nickName + ')  ' : ''
                          }`"
                      :value="value.userName"
                    ></el-option>
                  </template>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="手机号：" prop="noticeTitle">
                <el-input
                  size="small"
                  v-model="queryParams.phoneNumber"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="账号状态：" prop="time">
                <el-select
                  style="width: 100%"
                  clearable
                  size="small"
                  v-model="queryParams.status"
                >
                  <template
                    v-for="(value, key) in dictData['sys_normal_disable']"
                  >
                    <el-option
                      :key="value.value"
                      :label="value.label"
                      :value="value.value"
                    ></el-option>
                  </template>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="认证类型：" prop="auth_type">
                <el-select
                  size="small"
                  clearable
                  v-model="queryParams.authType"
                >
                  <template v-for="(value, key) in dictData['auth_type']">
                    <el-option
                      :key="value.value"
                      :label="value.label"
                      :value="value.value"
                    ></el-option>
                  </template>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="认证情况：" prop="authStatus">
                <el-select
                  size="small"
                  clearable
                  v-model="queryParams.authStatus"
                >
                  <template v-for="(value, key) in dictData['verify_status']">
                    <el-option
                      :key="value.value"
                      :label="value.label"
                      :value="value.value"
                    ></el-option>
                  </template>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="认证时间：" prop="time">
                <el-date-picker
                  size="small"
                  v-model="queryParams.time"
                  type="daterange"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="24" class="btn-bar-right">
              <el-button type="primary" size="small" @click="loadData"
                >搜索</el-button
              >
              <el-button size="small" @click="resetForm">重置</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <div class="form-body">
      <div style="overflow: hidden">
        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="queryParams.pageNum"
          :limit.sync="queryParams.pageSize"
          @pagination="loadData"
          :layout="'slot, total, sizes, prev, pager, next, jumper'"
        >
        </pagination>
      </div>
      <el-table border :data="tableData">
        <el-table-column width="169" label="注册时间" prop="noticeTitle">
          <template slot-scope="scope">
            {{ scope.row.createTime }}
          </template>
        </el-table-column>
        <el-table-column width="169" label="认证时间" prop="noticeTitle">
          <template slot-scope="scope">
            {{ scope.row.authTime }}
          </template>
        </el-table-column>
        <el-table-column width="119" label="商家账号" prop="noticeTitle">
          <template slot-scope="scope">
            <a style="cursor: pointer" @click="handleShowUserDetail(scope.row)">
              {{ scope.row.userName }}</a
            >
          </template>
        </el-table-column>
        <el-table-column width="119" label="手机号" prop="phoneNumber">
        </el-table-column>
        <el-table-column label="账号状态" prop="status">
          <template slot-scope="scope">
            <div>{{ scope.row.status == "1" ? "正常" : "停用" }}</div>
          </template>
        </el-table-column>
        <el-table-column label="认证资料" prop="attachId">
          <template slot-scope="scope">
            <a
              v-if="rowData.attachId"
              :href="scope.row.attachId"
              target="_blank"
              >点击下载</a
            >
          </template>
        </el-table-column>
        <el-table-column
          label="认证审核意见"
          prop="authOpinion"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.authOpinion }}
          </template>
        </el-table-column>
        <el-table-column label="认证情况" prop="authStatus">
          <template slot-scope="scope">
            {{ dictMap["verify_status"][scope.row.authStatus] }}
          </template>
        </el-table-column>
        <el-table-column label="操作" prop="oper" fixed="right" width="160">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="mini"
              v-if="scope.row.authStatus == '02' || !scope.row.authStatus"
              @click="handleShowEdit(scope.row)"
              >审核</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <pagination
        class="bottom-sticky"
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="loadData"
      />
    </div>

    <el-dialog
      :close-on-click-modal="false"
      :title="editDialog.title"
      :visible.sync="editDialog.dialogVisible"
      width="1280px"
    >
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        class="notice-form"
        label-width="140px"
      >
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="商家账号：" prop="userName">
              {{ rowData.userName }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="商家手机号：" prop="phoneNumber">
              {{ rowData.phoneNumber }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="注册时间：" prop="createTime">
              {{ rowData.createTime }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="认证类型：" prop="authType">
              {{ dictMap["auth_type"][rowData.authType] }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="法人姓名：" prop="legalName">
              {{ rowData.legalName }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="法人身份证：" prop="userName">
              {{ rowData.legalId }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="法人手机号：" prop="legalPhone">
              {{ rowData.legalPhone }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :label="rowData.authType == '02' ? '企业名称：' : '真实姓名：'"
              prop="enterprise"
            >
              {{ rowData.enterprise ? rowData.enterprise : rowData.legalName }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="统一信用代码：" prop="uniformCreditCode">
              {{ rowData.uniformCreditCode }}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="认证资料：" prop="attachId">
              <a
                v-if="rowData.attachId"
                :href="rowData.attachId"
                target="_blank"
                >点击下载</a
              >
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="认证结果：" prop="authStatus">
              <el-radio-group v-if="isEdit" v-model="form.authStatus">
                <template>
                  <el-radio label="03" key="03">通过</el-radio>
                  <el-radio label="04" key="04">不通过</el-radio>
                </template>
              </el-radio-group>
              <span v-else>{{
                dictMap["verify_status"][rowData.authStatus]
              }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="审核意见：" prop="authOpinion">
              <el-input
                v-model="form.authOpinion"
                v-if="isEdit"
                :rows="5"
                type="textarea"
              ></el-input>
              <span v-else>{{ rowData.authOpinion }}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="editDialog.dialogVisible = false"
          >关闭</el-button
        >
        <el-button v-if="isEdit" type="primary" size="small" @click="handleSave"
          >保存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import Breadcrumb from "@/components/common/Breadcrumb"
import { listAuth, auditAuth } from "@/api/business/merchantManage"
import { listUser } from "@/api/business/merchantManage"

export default {
  name: "Notice",
  components: {
    Breadcrumb,
  },
  data() {
    return {
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        noticeStatus: undefined,
        updateBy: undefined,
        noticeTitle: undefined,
        noticeType: undefined,
        beginTime: undefined,
        endTime: undefined,
        time: [],
      },
      form: {
        authStatus: "",
        userName: "",
        authOpinion: "",
      },
      total: 0,
      tableData: [],
      editDialog: {
        title: "",
        dialogVisible: false,
        noticeForm: {},
      },
      rules: {
        authStatus: [
          { required: true, message: "请选择认证结果", trigger: "blur" },
        ],
      },
      rowData: {},
      isEdit: false,
      userList: [],
    }
  },
  computed: {
    ...mapGetters(["dictData", "dictMap"]),
    ...mapGetters(["user"]),
  },
  created() {
    let curDate = new Date()
    let preDate = new Date(curDate.getTime() - 24 * 60 * 60 * 1000 * 7)

    this.queryParams.time = [
      this.parseTime(preDate, "{y}-{m}-{d}"),
      this.parseTime(curDate, "{y}-{m}-{d}"),
    ]
    this.loadData()
    this.getUserList()
  },
  methods: {
    async getUserList() {
      let result = await listUser({
        pageNum: 1,
        pageSize: 100000,
        userType: "01",
      })
      this.userList = result.rows
    },
    /** 查询公告列表 */
    loadData() {
      if (this.user.userType !== "00") {
        this.queryParams.noticeStatus = "1"
      }
      this.startLoading()
      if (this.queryParams.time) {
        this.queryParams.beginTime = this.queryParams.time[0]
        this.queryParams.endTime = this.queryParams.time[1]
      } else {
        this.queryParams.beginTime = ""
        this.queryParams.endTime = ""
      }
      let params = Object.assign({}, this.queryParams)
      delete params["time"]
      listAuth(params)
        .then((response) => {
          this.tableData = response.rows
          this.total = response.total
          this.endLoading()
        })
        .catch(() => {
          this.endLoading()
        })
    },

    resetForm() {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        noticeStatus: undefined,
        updateBy: undefined,
        noticeTitle: undefined,
        noticeType: undefined,
        beginTime: undefined,
        endTime: undefined,
        time: [],
      }
      this.$refs["form"].resetFields()
    },

    /**显示编辑页面 */
    handleShowEdit(row) {
      this.rowData = Object.assign({}, row)
      this.editDialog.title = "认证审核"
      this.isEdit = true
      this.editDialog.dialogVisible = true
      this.form = {
        authStatus: "",
        userName: "",
        authOpinion: "",
      }
      this.$nextTick(() => {
        this.$refs["form"].clearValidate()
      })
    },
    handleShowUserDetail(row) {
      this.rowData = Object.assign({}, row)
      this.editDialog.title = "认证审核"
      this.isEdit = false
      this.editDialog.dialogVisible = true
      this.$nextTick(() => {
        this.$refs["form"].clearValidate()
      })
    },

    /**保存公告信息 */
    handleSave() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.form.userName = this.rowData.userName
          if (this.form.authStatus == "04" && this.form.authOpinion == "") {
            this.$message.error("请输入审核意见")
            return
          }
          auditAuth(
            this._.pick(this.form, "userName", "authOpinion", "authStatus")
          ).then((response) => {
            if (response.code == "200") {
              this.$message.success("审核成功！")
              this.editDialog.dialogVisible = false
              this.loadData()
            } else {
              this.$message.error("审核失败")
            }
          })
        } else {
          console.log("error submit!!")
          return false
        }
      })
    },
    /**删除公告 */
    handleDeleteNotice(row) {
      this.$confirm("确认删除公告？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        deleteNotice(row).then((response) => {
          if (response.code == "200") {
            this.$message.success("删除成功！")
            this.loadData()
          } else {
            this.$message.error("删除失败！")
          }
        })
      })
    },
    /**详情 */
    handleShowDetail(row) {
      if (this.user.userType == "00") {
        this.$router.push({
          path: "/accessibility/category/notice_detail",
          query: { noticeId: row.noticeId },
        })
      } else {
        this.$router.push({
          path: "/system/advisory/announcement_detail",
          query: { noticeId: row.noticeId },
        })
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.btn-bar-right {
  text-align: right;
}
::v-deep .el-badge__content {
  position: relative;
  top: 6px;
  right: 30px;
}
.notice-form {
  padding: 10px 30px 0 0;
  height: 60vh;
  overflow: auto;
}
</style>
